import Page from '../page';

export default class AboutIndex extends Page {
    constructor(...args) {
        super(...args);

        this._retrieveDOM();
        this._initTls();
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/about/about-index.js